<template>
  <div>
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h4>Guest value</h4>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Guest value</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <strong
            ><p>{{ value ? value.sum : 0 }} points</p></strong
          >
        </div>
      </div>

      <vs-table v-if="value" :data="value.points">
        <template slot="header"> </template>
        <template slot="thead">
          <vs-th> Points </vs-th>
          <vs-th> Date </vs-th>
          <vs-th> Expires </vs-th>
          <vs-th> Duration </vs-th>
          <vs-th> Expired </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">
                {{ tr.points }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">
                {{ moment(tr.givenDate).format("DD-MM-YYYY") }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">
                {{ moment(tr.expireDate).format("DD-MM-YYYY") }}
              </p>
            </vs-td>

            <vs-td>
              <vs-chip color="primary" class="product-order-status">
                {{ tr.duration }}
              </vs-chip>
            </vs-td>

            <vs-td>
              <p class="status-category">
                <vs-chip
                  :color="!tr.expired | yesnocolor"
                  class="status-circle"
                ></vs-chip>
                {{ tr.expired | yesno }}
              </p>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},

  data() {
    return {
      // eslint-disable-next-line
      _,
      moment,
      value: null,
      profileId: "",
    };
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {},
  async created() {
    this.profileId = this.$route.params.id;
    await this.$store.dispatch("guestProfiles/getGuestValue", this.profileId, false);
    this.value = this.$store.getters["guestProfiles/value"](this.profileId);
  },
};
</script>

<style lang="scss" scoped>
.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}
</style>